import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import flexbox from 'styles/utils/flexbox';

function MapMarkerPopupPlaceholderComponent({ theme }) {
  return (
    <ThemeProvider theme={theme}>
      <PlaceholderStyled>
        <Image />
        <Header />
        <Footer>
          <FooterLeft />
          <FooterRight />
        </Footer>
      </PlaceholderStyled>
    </ThemeProvider>
  );
}

export default MapMarkerPopupPlaceholderComponent;

const PlaceholderStyled = styled.div`
  padding: 15px;
`;

const separatorMargin = '8px';
const borderRadius = '4px';

const BasePlaceholder = styled.div`
  background-color: ${({ theme }) => theme.colors.background.placeholder};
  border-radius: ${borderRadius};
  margin-bottom: ${separatorMargin};

  animation: react-placeholder-pulse 0.7s infinite;
`;

const Image = styled(BasePlaceholder)`
  width: 300px;
  height: 190px;
`;

const Header = styled(BasePlaceholder)`
  width: 300px;
  height: 55px;
`;

const Footer = styled.div`
  ${flexbox({
    justifyContent: 'space-between',
  })}
`;

const FooterLeft = styled(BasePlaceholder)`
  width: 220px;
  height: 55px;
  margin-bottom: 0;
`;

const FooterRight = styled(BasePlaceholder)`
  width: 50px;
  height: 55px;
  margin-bottom: 0;
`;
